import { useMemo } from 'react'
import { useInspectorContext } from './inspector'
import { useArtboardDetailContext } from './useArtboardDetailContext'

/**
 * The Zoom component takes an optional prop `gridAndLayout` which contains
 * props to show and control the toggles for grid and layout in the zoom dropdown.
 * The result of this hook can be fed directly to the Zoom component.
 */
export function useGridAndLayoutPropForZoomComponent() {
  const { isInspectorActive } = useInspectorContext()
  const {
    isGridEnabled,
    isLayoutEnabled,
    toggleGrid,
    toggleLayout,
  } = useArtboardDetailContext()

  const gridAndLayout = useMemo(() => {
    if (!isInspectorActive) {
      return undefined
    }

    return {
      isGridEnabled,
      isLayoutEnabled,
      toggleGrid,
      toggleLayout,
    }
  }, [
    isGridEnabled,
    isInspectorActive,
    isLayoutEnabled,
    toggleGrid,
    toggleLayout,
  ])

  return gridAndLayout
}
